import { render } from "./programDropdown.vue?vue&type=template&id=31f53df1&ts=true"
import script from "./programDropdown.vue?vue&type=script&lang=ts"
export * from "./programDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__